export default {
  Top: 1,
  Bottom: 2,
  Both: 3
};
